"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSearch = exports.ActiveLabel = exports.CardLabel = exports.AccountThumbnail = exports.CardContainer = exports.AccountCardWrapper = exports.AccountCardsScrollContainer = exports.AccountCardsContainer = exports.AccountsListModalContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  width: 89%;\n  margin: auto;\n  display: block;\n  height: 30px;\n  margin-bottom: 12px;\n  border: none;\n  border-bottom: 1px solid #eee;\n  font-family: Brandon;\n  font-size: 13px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n  float: right;\n  background-color: #f81861;\n  border-radius: 4px;\n  padding: 4px;\n  position: absolute;\n  right: 17px;\n  bottom: 16px;\n\n  span {\n    color: white;\n    font-size: 8px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding: 18px 28px;\n  font-size: 14px;\n  color: #596c78;\n  position: relative;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background: #273037;\n  height: 160px;\n  position: relative;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 4px 0 0 4px;\n\n  @media screen and (max-width: 1400px){\n    height: 120px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  cursor: pointer;\n  background: white;\n  border-radius: 4px;\n  overflow: hidden;\n  margin: 4px;\n  box-shadow: 0 5px 9px 0 rgba(0, 0, 0, 0.05);\n  text-align: left;\n  transition: all .2s ease-out;\n\n  &:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 11px 9px 0 rgba(0, 0, 0, 0.1);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: top;\n  display: inline-block;\n  width: 50%;\n\n  @media only screen and (min-width: 1250px) {\n    width: 25%;\n  }\n\n  @media only screen and (min-width: 1300px) {\n    width: 20%;\n  }\n\n  @media only screen and (min-width: 1500px) {\n    width: 16.66%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 90%;\n  margin: auto;\n  height: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  height: 90%;\n  padding-top: 42px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 575px;\n  background-color: white;\n  width: 700px;\n\n  @media only screen and (min-width: 1100px) {\n    width: 900px;\n  }\n\n  @media only screen and (min-width: 1300px) {\n    width: 1000px;\n  }\n\n  @media only screen and (min-width: 1500px) {\n    width: 1400px;\n  }\n\n  @media only screen and (min-width: 1700px) {\n    width: 1600px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AccountsListModalContainer = _styledComponents["default"].div(_templateObject());

exports.AccountsListModalContainer = AccountsListModalContainer;

var AccountCardsContainer = _styledComponents["default"].div(_templateObject2());

exports.AccountCardsContainer = AccountCardsContainer;

var AccountCardsScrollContainer = _styledComponents["default"].div(_templateObject3());

exports.AccountCardsScrollContainer = AccountCardsScrollContainer;

var AccountCardWrapper = _styledComponents["default"].div(_templateObject4());

exports.AccountCardWrapper = AccountCardWrapper;

var CardContainer = _styledComponents["default"].div(_templateObject5());

exports.CardContainer = CardContainer;

var AccountThumbnail = _styledComponents["default"].div(_templateObject6());

exports.AccountThumbnail = AccountThumbnail;

var CardLabel = _styledComponents["default"].div(_templateObject7());

exports.CardLabel = CardLabel;

var ActiveLabel = _styledComponents["default"].div(_templateObject8());

exports.ActiveLabel = ActiveLabel;

var AccountSearch = _styledComponents["default"].input(_templateObject9());

exports.AccountSearch = AccountSearch;

//# sourceMappingURL=styled.js.map